import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurwoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Huurwoning_svg__a)">
      <mask
        id="Huurwoning_svg__b"
        width={19}
        height={21}
        x={4}
        y={12}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="m13.5 12-9 5.94V33h4v-8h5v8h9V17.94z"
        />
      </mask>
      <g mask="url(#Huurwoning_svg__b)">
        <path
          fill="#F18700"
          d="M22.2 38.06 9.95 30.99l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m-2.29 23.92 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m2.88 43.24 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="M17.02 18.74 9.95 30.99l-12.24-7.07z"
        />
        <path
          fill="#F7A941"
          d="m-7.47 4.6 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="M17.02 18.74 4.78 11.67 11.85-.58z"
        />
        <path
          fill="#F7A941"
          d="m-2.29 23.92 7.07-12.25 12.24 7.07z"
        />
        <path
          fill="#F18700"
          d="m17.02 18.74 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m22.2 38.06 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m36.34 13.56-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="m41.52 32.88-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F18700"
          d="m11.85-.58 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m17.02 18.74 7.07-12.25 12.25 7.07z"
        />
      </g>
      <mask
        id="Huurwoning_svg__c"
        width={17}
        height={22}
        x={19}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M19.5 7v22h16V7zM29 25.5h-6.5v-1H28V23h1zm3.5-10h-10v-1h10zm0-4h-10v-1h10z"
        />
      </mask>
      <g mask="url(#Huurwoning_svg__c)">
        <path
          fill="#F7A941"
          d="M30.6 10.18 18.35 3.11l7.08-12.25z"
        />
        <path
          fill="#F7A941"
          d="m11.28 15.36 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#FED27A"
          d="m11.28 15.36 12.25 7.07-7.07 12.25zM35.78 29.5l-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m30.6 10.18-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#FED27A"
          d="m16.46 34.68 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F7A941"
          d="m25.43-9.14 12.24 7.07-7.07 12.25zM30.6 10.18l7.07-12.25L49.92 5z"
        />
        <path
          fill="#FED27A"
          d="m30.6 10.18 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#FED27A"
          d="m49.92 5-7.07 12.25-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Huurwoning_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurwoning);

export default ForwardRef;
